import React from 'react';
import styled from 'styled-components';
import { Skeleton as AntdSkeleton } from 'antd';
import { SkeletonInputProps as AntdSkeletonInputProps } from 'antd/lib/skeleton/Input';

export type SkeletonInputProps = Omit<AntdSkeletonInputProps, 'active'>;

export const SkeletonInput = styled(({ ...props }: SkeletonInputProps) => <AntdSkeleton.Input {...props} active />)``;

export default SkeletonInput;
